import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 pe-10" }
const _hoisted_10 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_11 = { class: "form-check form-check-primary" }
const _hoisted_12 = ["onChange", "id", "onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t('feature.roles.centers_permissions')), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createCommentVNode(" <div class=\"mb-15 d-sm-flex align-items-center justify-content-between\">\n                <h5 class=\"fw-medium text-black-emphasis mb-0\">{{ $t('feature.roles.centers_permissions') }}</h5>\n            </div> "),
      (_ctx.centers === undefined || _ctx.permissions === undefined)
        ? (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
                    return (_openBlock(), _createElementBlock("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0",
                      key: action
                    }, _toDisplayString(_ctx.$t(`feature.roles.$permissions.${action}`)), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createCommentVNode(" PERMISSION ROW "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.centers, (center) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: center.id
                  }, [
                    _createElementVNode("th", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(center.name), 1 /* TEXT */)
                    ]),
                    _createCommentVNode(" ACTIONS "),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
                      return (_openBlock(), _createElementBlock("td", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis",
                        key: action
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input shadow-none",
                            type: "checkbox",
                            onChange: ($event: any) => (_ctx.updateRolePermission(center, action)),
                            id: `${center.id}-${_ctx.id}-${action}`,
                            "onUpdate:modelValue": ($event: any) => ((center.role_permissions[action]) = $event)
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12), [
                            [_vModelCheckbox, center.role_permissions[action]]
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
    ])
  ]))
}